import spinner from '../../assets/img/spinner.svg';
import '../../assets/css/modal.css';

const Spinner = ({visible}) => {
    return (
        <div className={`modal_wrap spinner${visible ? ' show' : ''}`}>
            <div className="loading_icon">
                <img src={spinner} alt="Loading..." />
            </div>
        </div>
    );
};

export default Spinner;